import React, { useRef } from 'react'
import { Spinner } from '../Loaders/Loaders'
import CartIcon from '@tecuity/sos-icons/react/cart'
import GearsIcon from '@tecuity/sos-icons/react/gears'
import SearchIcon from '@tecuity/sos-icons/react/search'
import TrashIcon from '@tecuity/sos-icons/react/trash'
import DatabaseIcon from '@tecuity/sos-icons/react/database'
import RSSIcon from '@tecuity/sos-icons/react/rss'
import ReactTooltip from 'react-tooltip'
import format from 'date-fns/format'
import shortid from 'shortid'
import { usePrevious } from '../../Utilities/hooks'

const DATA_REQUEST_TOOLTIP = process.env.DATA_REQUEST_TOOLTIP
// const DATA_REQUESTS_IN_SHOPPING_CART = process.env.DATA_REQUESTS_IN_SHOPPING_CART

const PENDING_ONLINE_PAYMENT_PROCESSING_STATUS_ID = 535

const STATUSES = {
  1071: {
    text: 'Active',
    className: 'dr-active',
  },
  1072: {
    text: 'Cancelled',
    className: 'dr-cancelled',
  },
  1073: {
    text: 'Cancelled - Failed Payment',
    className: 'dr-failed',
  },
  1074: {
    text: 'Complete',
    className: 'dr-complete',
  },
  1077: {
    text: 'Paused',
    className: 'dr-paused',
  },
}

const TYPES = {
  1080: {
    text: 'Existing',
    className: 'existing',
    icon: DatabaseIcon,
  },
  1081: {
    text: 'current',
    className: 'single',
    icon: DatabaseIcon,
  },
  1082: {
    text: 'reocurring',
    className: 'subscription',
    icon: RSSIcon,
  },
}

const getStatusById = (id) => STATUSES[id] || { className: '', text: '' }
const getTypeById = (id) => TYPES[id] || { className: '', text: '' }

export default ({
  Name,
  ProcessingStatusId,
  NAME_OVERRIDE,
  STATUS_RO,
  STATUS_ID,
  DATA_REQUEST_TYPE_ID,
  CreatedDate,
  ExpirationDate,
  onManageClicked,
  onDownloadsClicked,
  onAddToCartClicked,
  OnDeleteClicked,
  isActive,
  checkoutOpen,
  useSearchIcon,
  onSearchClicked,
}) => {
  const [checkoutPending, setCheckoutPending] = React.useState(false)
  const status = getStatusById(STATUS_ID)
  const type = getTypeById(DATA_REQUEST_TYPE_ID)
  const id = useRef(shortid.generate())
  const prevCheckoutOpen = usePrevious(checkoutOpen)

  const handleCartClicked = (e) => {
    setCheckoutPending(true)
    onAddToCartClicked(e)
  }

    const handleDeleteClicked = (e) => {  
      OnDeleteClicked(e)  
  }

  React.useEffect(() => {
    if (prevCheckoutOpen === false && checkoutOpen === true) {
      setCheckoutPending(false)
    }
  }, [checkoutOpen, prevCheckoutOpen])

  return (
    <li
      className={`data-request-block ${status.className} ${type.className} ${
        isActive ? 'active' : ''
      }`}
    >
      <h1 className="dr-title-wrapper">
        <span className="dr-title">{NAME_OVERRIDE || Name}</span>
        <span className="dr-subtitle">
          {type.icon ? <type.icon /> : null}
          <span className="date">
            {format(new Date(CreatedDate), 'MM/dd/yyyy')}
            {ExpirationDate ? " - " + format(new Date(ExpirationDate), 'MM/dd/yyyy') : ''}
          </span>
          <span className="visually-hidden">Status: </span>
          {STATUS_RO}
        </span>
      </h1>
      <div className="dr-buttons">
        {ProcessingStatusId === PENDING_ONLINE_PAYMENT_PROCESSING_STATUS_ID ? (
          <button
            className="fixed trash-button"
            aria-label={`Delete request ${Name}`}
            onClick={handleDeleteClicked}
            data-for={id.current}
            data-tip={'Delete'}
            disabled={checkoutPending}
          >
            {checkoutPending && !checkoutOpen ? (
              <Spinner size="medium" themeColor="dark-neutral" />
            ) : (
              <TrashIcon />
            )}
          </button>
        ) : null}        
        {ProcessingStatusId === PENDING_ONLINE_PAYMENT_PROCESSING_STATUS_ID ? (
          <button
            className="fixed cart-button"
            aria-label={`Add request ${Name} to cart`}
            onClick={handleCartClicked}
            data-for={id.current}
            data-tip={'Add to Cart'}
            disabled={checkoutPending}
          >
            {checkoutPending && !checkoutOpen ? (
              <Spinner size="medium" themeColor="dark-neutral" />
            ) : (
              <CartIcon />
            )}
          </button>
        ) : null}
        {useSearchIcon && (
          <button
            className="fixed first"
            aria-label={`Manage data request for ${Name}`}
            onClick={onSearchClicked}
            data-for={id.current}
            data-tip={DATA_REQUEST_TOOLTIP || 'View Details'}
          >
            <SearchIcon />
          </button>
        )}
        <button
          className="fixed"
          aria-label={`Manage data request for ${Name}`}
          onClick={onManageClicked}
          data-for={id.current}
          data-tip={DATA_REQUEST_TOOLTIP || 'View Details'}
        >
          <GearsIcon />
        </button>
        <ReactTooltip effect="solid" id={id.current} delayShow={1000} />
        <button aria-label={`View downloads for ${Name}`} onClick={onDownloadsClicked}>
          View Downloads
        </button>
      </div>
    </li>
  )
}
